import { getCurrentInstance } from "vue";

import actions from "@/vuex/actions";
import store from "@/vuex/store";

// Quick type hack to get decent typings from the store
type ActionsType = typeof actions;
type TypedStore = Omit<typeof store, "dispatch"> & {
  dispatch: <T extends keyof ActionsType>(
    action: T,
    data?: Parameters<ActionsType[T]>[1] extends undefined
      ? any
      : Parameters<ActionsType[T]>[1]
  ) => ReturnType<ActionsType[T]>;
};

export function useStore() {
  return getCurrentInstance()!.proxy.$store as TypedStore;
}
